import { i18n } from '@/i18n'

export default (params) => {
  return [
    {
      icon: 'procedingmenu',
      name: i18n.t('procedings.title'),
      path: 'procedings',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'procedings/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('app.historical'),
          path: 'procedings/historical',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        }
      ]
    }
  ]
}
